import styled from "styled-components";

export const StyledDiv = styled.div`
  .Polaris-Stack {
    flex-wrap: nowrap;
  }
`;
